import { Breadcrumb } from "@app/shared/components";
import { contactUsAtom } from "@core/contact-us/atom";
import { URLS } from "@core/shared/utils";
import { trans } from "@mongez/localization";
import {
  ContactForm,
  ContactInformation,
  SuccessContactMessage,
} from "../components";

export function ContactUsPageContent() {
  const successRequest = contactUsAtom.useValue();

  if (successRequest) return <SuccessContactMessage />;

  return (
    <div className="min-h-screen dark:bg-gray-900">
      <div className="relative">
        {/* Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-primary/5 dark:bg-primary/10 blur-3xl" />
          <div className="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-primary/5 dark:bg-primary/10 blur-3xl" />
        </div>

        <div className="container relative mx-auto px-4 py-12">
          <Breadcrumb
            items={[
              { text: trans("home.title"), url: URLS.home },
              { text: trans("contactUs"), url: URLS.contactUs },
            ]}
          />

          <div className="mt-16">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-900 dark:text-white md:text-5xl">
                {trans("contactUs")}
              </h1>
              <div className="mt-4 h-1 w-20 bg-primary mx-auto rounded-full" />
            </div>

            <div className="mt-16 grid gap-8 lg:grid-cols-12">
              {/* Contact Information - Takes 4 columns on large screens */}
              <div className="lg:col-span-4">
                <div className="sticky top-8">
                  <div className="rounded-2xl bg-gray-50 p-8 dark:bg-gray-800">
                    <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
                      {trans("getInTouch")}
                    </h2>
                    <div className="mt-6">
                      <ContactInformation />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Form - Takes 8 columns on large screens */}
              <div className="lg:col-span-8">
                <div className="rounded-2xl border border-gray-200 bg-white p-8 dark:border-gray-700 dark:bg-gray-800">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
